import React from 'react'
import { renderSvg } from '@utils/genUtils'
import { svgs } from '@svg'
import { GridFluid } from '@styles/global/cssGrid'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'

function Footer() {
  return (
    <FooterContainer>
      <GridFluid>

        {/*footer-col-1*/}
        <FooterLogo>
          <a href='https://every-tuesday.com/courses' rel='noreferrer'>
            {renderSvg(svgs.ETLogo)}
          </a>
        </FooterLogo>

        {/*footer-col-2*/}
        <FooterNav>

          <FooterNavItem>
            <h6>PRODUCTS</h6>

            <ul>
              <li>
                <a href='https://every-tuesday.com/courses/' rel='noreferrer'>Courses</a>
              </li>
              <li>
                <a href='https://every-tuesday.com/category/tutorials/' rel='noreferrer'>Tutorials</a>
              </li>
              <li>
                <a href='https://every-tuesday.com/category/freebies/' rel='noreferrer'>Freebies</a>
              </li>
            </ul>

          </FooterNavItem>

          <FooterNavItem>
            <h6>Contact</h6>

            <ul>
              <li>
                <a href='https://every-tuesday.com/contact/' rel='noreferrer'>Contact</a>
              </li>
              <li>
                <a href='https://every-tuesday.com/about/' rel='noreferrer'>About</a>
              </li>
              <li>
                <a href='https://every-tuesday.com/blog/' rel='noreferrer'>Blog</a>
              </li>
            </ul>

          </FooterNavItem>

          <FooterNavItem>
            <h6>Misc</h6>

            <ul>

              <li>
                <a href='https://every-tuesday.com/licenses/' rel='noreferrer'>Licenses</a>
              </li>
              <li>
                <a href='https://every-tuesday.com/privacy-policy/' rel='noreferrer'>Privacy Policy</a>
              </li>
            </ul>

          </FooterNavItem>


        </FooterNav>

        {/*footer-col-3*/}
        <FooterSocialMedia>
          {/*<h6>FOLLOW US</h6>*/}

          <div>
            <a href='https://facebook.com/everytues' rel='noreferrer' target='_blank'>
              {renderSvg(svgs.Facebook)}
            </a>

            <a href='https://twitter.com/teelacunningham' rel='noreferrer' target='_blank'>
              {renderSvg(svgs.Twitter)}
            </a>

            <a href='https://youtube.com/everytues' rel='noreferrer' target='_blank'>
              {renderSvg(svgs.Youtube)}
            </a>

            <a href='https://instagram.com/everytuesday' rel='noreferrer' target='_blank'>
              {renderSvg(svgs.Instagram)}
            </a>

            <a href='https://www.pinterest.com/teelac/' rel='noreferrer' target='_blank'>
              {renderSvg(svgs.Pinterest)}
            </a>
          </div>

        </FooterSocialMedia>
      </GridFluid>
    </FooterContainer>
  )
}

const ItemStyles = styled.div`
  h6{
    color: ${props => props.theme.headlineColor};
    font-size: .8rem;
    text-transform: uppercase;
  }
    
  a{
    color: ${props => props.theme.textColor};
    font-size: .9rem;
    &:hover{
      color: ${props => props.theme.highlight.i500};
    }
  }`
const FooterLogo = styled.div`
  grid-column: 2 / 4;
  a{
    width: 100%;
    display: block;
    max-width: 250px;
    margin: 0 auto;
  }
  svg{
    max-width: 250px;
    margin: 0 auto;
    width: 100%;
      path{
        fill: ${props => props.theme.logoColor};
      }
    }
  @media ${device.tablet}{
    grid-column: 2 / 5;
    a{
      max-width: none;
    }
  }
`
const FooterNavItem = styled(ItemStyles)`
  flex: 1;
  margin-bottom: 30px;
  ul{
    margin: 0;
    padding: 0;
    list-style: none;
  }
  @media ${device.tablet}{
    margin-bottom: 0; 
  } 
`
const FooterSocialMedia = styled(ItemStyles)`
  grid-column: 2 / 4;
  padding: 50px 0 0;

  div{
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items:flex-start;
    max-width: 300px;
    margin: 0 auto;
  }

  a{
    flex: 1;
    text-align: center;
    &:hover{
      svg{
        path{
          fill: ${props => props.theme.buttonPrimary.hoverColor};
        }
      }
    }
  }
  
  svg{
    width: 20px;
    path {
      transition: .3s;
      fill: ${props => props.theme.logoColor};
    }
  }
    @media ${device.tablet}{
      grid-column: 2 / 14; 
    }
    @media ${device.laptopL}{
      text-align: left;
      grid-column: 11 / 14;
      padding: 0;
      div{
        margin: 0 auto 0 0;
      }
    }
      
`
const FooterNav = styled.nav`
  grid-column: 2 / 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  @media ${device.tablet}{
    grid-column: 5 / 14 ;
    flex-direction: row;
    margin-left: 60px;
    text-align: left;
    align-items: flex-start;
  } 
  @media ${device.laptop}{
    grid-column: 7 / 14;
  }
  @media ${device.laptopL}{
    margin-left: 0;
    margin-right: 5%;
    grid-column: 6 / 11; 
  }
   
`

const FooterContainer = styled.footer`
  background: ${props => props.theme.backgroundPrimary};
  padding: 80px 0;
`
export default Footer